interface InsuranceType {
  id: string
  textMe: string
  textNotMe: string
  textOptionalCoverageSelectInfo: string
  disabled: boolean
  default: boolean
}

export default class LifeConfigurationInsuranceTypes {
  family: InsuranceType
  mortgage: InsuranceType

  constructor(data: LifeConfigurationInsuranceTypes) {
    this.family = data.family
    this.mortgage = data.mortgage
  }
}
